import { sendRequest } from "../request";
const BASE_URL = '/api/trademarkApplications';

export function getTrademarkApplications(user) {
    return sendRequest(`${BASE_URL}/getTrademarkApplications/${user._id}`);
}